export default "__VITE_ASSET__BEgc50TB__"